<template>
  <div class="bubble" :class="{ me: from == 'me', loading: loading }" v-html="text"></div>
</template>

<style lang="sass" scoped>
.bubble
    padding: 12px
    border-radius: 22px
    color: #202124
    border: 1px solid #E8EAED
    display: inline-block
    position: relative
    background-color: white
    max-width: 60%
    min-width: 22px
    white-space: pre-wrap
    &.me
        background-color: #F1F3F4
        border: 1px solid #F1F3F4
        color: #5F6368
        float: right
        white-space: normal

        &::before
            content: ''

    &.loading
        width: 20px
        height: 16px
        animation: loading .8s ease infinite

@keyframes loading
    0%
        opacity: 0
    50%
        opacity: 1
    100%
        opacity: 0
</style>

<script>
export default {
  name: "Bubble",
  props: ["text", "from", "loading"]
};
</script>
